import { Stack, Typography } from '@mui/material'

import { ContentFrame } from '@/components/layouts/ContentFrame'
import {
  SMSVerificationForm,
  SMSVerificationFormProps,
} from '@/components/pages/SMSVerification/template/SMSVerificationForm'
import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

import { Header } from './Header'

export type BuyNowSMSVerificationProps = {
  verifyingSMSCode: boolean
  phoneNumber: string
  onVerificationPhoneNumber: SMSVerificationFormProps['onSubmit']
  onResendVerificationSMS: SMSVerificationFormProps['onResend']
  onClose: () => void
}

export const BuyNowSMSVerification: Organism<BuyNowSMSVerificationProps> = ({
  verifyingSMSCode,
  phoneNumber,
  onVerificationPhoneNumber,
  onResendVerificationSMS,
  onClose,
}) => {
  const { t } = useTranslation('smsVerification')
  return (
    <OrganismFrame>
      <Header
        back
        title={t('smsVerificationTitle', 'SMS認証')}
        onClose={onClose}
      />
      <ContentFrame>
        <Stack sx={{ px: 5, pt: 4 }}>
          <Typography variant="body2" sx={{ pt: 2 }}>
            {t('description', { phoneNumber })}
          </Typography>
          <SMSVerificationForm
            loading={verifyingSMSCode}
            onSubmit={onVerificationPhoneNumber}
            onResend={onResendVerificationSMS}
          />
        </Stack>
      </ContentFrame>
    </OrganismFrame>
  )
}
